import React, {createContext, useCallback, useContext, useState} from 'react';
import {initialFilter} from "./OrdersListUIHelpers";
import {isEqual, isFunction} from "lodash";

const OrdersListUIContext= createContext();

export function useOrdersListUIContext(){
    return useContext(OrdersListUIContext);
}

export function OrdersListUIProvider({ordersListUIEvents, children}){
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [ids, setIds] = useState([]);
    const setQueryParams = useCallback((nextQueryParams) =>{
        setQueryParamsBase((prevQueryParams =>{
            if(isFunction(nextQueryParams)){
                nextQueryParams = nextQueryParams(prevQueryParams);
            }
            if(isEqual(prevQueryParams, nextQueryParams)){
                return prevQueryParams;
            }
            return nextQueryParams;
        }))
    }, []);
    
    const initOrder = {
        id: undefined,
        name: "",
        status: 0
    }
    
    const value = {
        queryParams,
        setQueryParamsBase,
        ids,
        setIds,
        setQueryParams,
        initOrder,
        openViewOrderPage: ordersListUIEvents.openViewOrderPage
    }
    
    return(
        <OrdersListUIContext.Provider value={value}>
            {children}
        </OrdersListUIContext.Provider>
    )
}